import { Box, Flex, HexagonErrorIcon } from "@caspeco/casper-ui-library";
import {
	ThemeColorVariable,
	ThemeRadiusVariable,
	ThemeShadowVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import rg4js from "raygun4js";
import { Component, ErrorInfo, ReactNode } from "react";
import LogoutButton from "../../components/logout-button";
import EmptyState from "../../components/empty-state";
import "../../layout/layout.css";
import { SIZE_LIMIT } from "../../constants";
import ReloadButton from "../../components/reload-button";

interface Props {
	children?: ReactNode;
	/**
	 * Should only be true for the boundary that wraps the whole application
	 */
	wrapper?: boolean;
}

interface State {
	hasError: boolean;
	error?: string;
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
		error: undefined,
	};

	public static getDerivedStateFromError(_: Error): State {
		// Update state so the next render will show the fallback UI.
		console.log(_);
		return { hasError: true };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		this.setState({ error: error.message });
		console.error("Uncaught error:", error, errorInfo);
		rg4js("send", { error: error, customData: errorInfo });
	}

	public render() {
		const { wrapper = false } = this.props;
		const isDesktopSize = window.innerWidth > SIZE_LIMIT;
		if (this.state.hasError) {
			return (
				<Flex
					direction={"column"}
					className="layout-container"
					justify={"center"}
					alignContent={"center"}
					h="100vh"
				>
					<Box
						className="error-container"
						boxShadow={ThemeShadowVariable.Header}
						bg={ThemeColorVariable.Background}
						borderRadius={isDesktopSize ? ThemeRadiusVariable.Large : ThemeRadiusVariable.None}
						p={wrapper ? ThemeSpaceVariable.Medium : ""}
						py={ThemeSpaceVariable.X2Large}
					>
						<Flex flexDirection={"column"} justify={"space-between"} h="100%">
							<EmptyState
								text={"error_text"}
								title="error_toast_title"
								icon={HexagonErrorIcon}
								error={this.state.error}
								buttons={[<ReloadButton key="reload" />, <LogoutButton key="logout" />]}
							/>
						</Flex>
					</Box>
				</Flex>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
